import React from "react";
import styled from "styled-components";

import {
  Modal,
  ModalButton,
  ModalCancelButton,
  ModalFooter,
} from "../../../../components/common/Modal";
import { COLORS } from "../../../../constants";

interface DeleteDashboardModalProps {
  visible: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const Body = styled.p`
  width: 100%;
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: ${COLORS.black50};
`;

export const DeleteDashboardModal: React.FC<DeleteDashboardModalProps> = ({
  visible,
  isLoading,
  onConfirm,
  onCancel,
}) => (
  <Modal
    title="Permanently delete this dashboard?"
    visible={visible}
    onClose={onCancel}
    width={480}
  >
    <Body>Once deleted, this dashboard will no longer be accessible by anyone.</Body>
    <ModalFooter>
      <ModalCancelButton onClick={onCancel}>Cancel</ModalCancelButton>
      <ModalButton variant="danger" onClick={onConfirm} disabled={isLoading}>
        Permanently delete
      </ModalButton>
    </ModalFooter>
  </Modal>
);
